// removed by extract-text-webpack-plugin
module.exports = {"DigitInput":"purify_DigitInput__DigitInput___1W473","selected":"purify_DigitInput__selected___1YBDV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DigitInput/DigitInput.scss
// module id = 254
// module chunks = 0